import { useQuery } from 'react-query';
import { useAPI } from '.';
import { CacheKeys } from '../constants';
import { useCallback } from 'react';
const useSkillsQuery = () => {
    const { get } = useAPI();
    return useQuery(CacheKeys.SKILLS, () => get({ url: '/skills' }).then((res) => res.data.records));
};
export const useSkills = () => {
    const { data: skills = [], isLoading } = useSkillsQuery();
    const findByValue = useCallback((value) => {
        const skill = skills.find((skill) => skill.value === value);
        if (skill)
            return skill;
        return {
            name: value
                .split('_')
                .map((v) => v[0].toUpperCase() + v.substring(1))
                .join(' ')
        };
    }, [skills]);
    return {
        isLoading,
        all: skills,
        active: skills.filter((skill) => skill.active),
        findByValue
    };
};
//# sourceMappingURL=useSkills.js.map